import { useEffect, useState } from "react";
import { getData } from "../../../webService/webservice.js";
import { useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import "../../../styles/Auth/CampaignHistory.css";
import "../../../styles/Auth/campaign.css"
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import { Icon } from "@iconify/react";
const CampaignHistoryPage = () => {
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [histories, setHistory] = useState([]);
    const [totals, setTotals] = useState({ totalSent: 0, totalFailed: 0 });
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);

    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Customer Name',
        'Customer Email',
        'Campaign Name',
        'Campaign Type',
        'Action',
    ];

    useEffect(() => {
        fetchHistory(page, limit, selectedStoreId);
    }, [page, limit, selectedStoreId]);

    const fetchHistory = async (page, limit, storeId) => {
        try {
            setLoading(true);

            const token = localStorage.getItem("Token");
            const response = await getData("campaigns/campaign/history", { page, limit, storeId }, token);

            const rawData = response?.data;
            let results = [];
            if (Array.isArray(rawData)) {
                results = rawData;
            } else if (rawData?.campaigns && Array.isArray(rawData.campaigns)) {
                results = rawData.campaigns;
            } else if (rawData?.results && Array.isArray(rawData.results)) {
                results = rawData.results;
            }

            const pagination = response?.pagination || response?.data?.pagination || {};
            const totalsData = response?.totals?.[0] || { totalSent: 0, totalFailed: 0 };
            setHistory(results);
            setTotals(totalsData);
            setTotalCount(pagination.totalCount || pagination.totalCustomers || results.length || 0);
            setTotalPages(pagination.totalPages || 1);
        } catch (error) {
            console.error("❌ Failed to fetch campaign history", error);
        } finally {
            setLoading(false);
        }
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value); // 👈 allow "all"
        setLimit(newLimit);
        setPage(1); /// reset to page 1 when changing limit
    };

    const handlePageChange = (direction) => {
        if (direction === "first") setPage(1);
        else if (direction === "last") setPage(totalPages);
        else if (direction === "prev" && page > 1) setPage(page - 1);
        else if (direction === "next" && page < totalPages) setPage(page + 1);
    };

    const handleViewCampaign = (customer) => {
        const campaignDetails = {
            campaignName: customer.campaignName,
            campaignType: customer.campaignType,
            storeId: customer.storeId,
            description: customer.description || "-",
            messageTemplate: customer.messageTemplate || "-",
            campaignAssets: customer.campaignAssets || [],
            customerHistory: [
                {
                    email: customer.email,
                    status: customer.status,
                    startedAt: customer.startedAt,
                    completedAt: customer.completedAt
                }
            ]
        };

        navigate("/campaign/history/view", { state: { campaign: campaignDetails } });
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className="campaign-layout">
            <div className="campaign-content">
                <main className="campaign-main">
                    <div className="campaign-history-container">
                        <div className="campaign-history-Titles">
                            <h2 className="history-title">Campaign History</h2>
                            {totals && (
                                <>
                                    <div className="total-sent-container">
                                        <p className="total-sent-title">
                                            Email Sent : {totals.totalSent}
                                        </p>
                                    </div>
                                    <div className="total-sent-container">
                                        <p className="total-unsent-title">
                                            Email UnSent : {totals.totalFailed}
                                        </p>
                                    </div>
                                </>
                            )}

                        </div>

                        <TableContainer component={Paper} className="history-table"
                            sx={{
                                borderRadius: '12px',
                                maxHeight: 400,   // fixed height for table container
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',

                            }}>
                            <Table stickyHeader
                                className="custom-product-table"
                                sx={{
                                    '& td, & th': {
                                        border: 'none',
                                    },
                                    border: 'none',
                                }}>
                                <TableHead className="custom-product-head">
                                    <TableRow>
                                        {headings.map((heading, index) => {
                                            const iscampaignName = heading === "Name";
                                            const isCampaignType = heading === "Campaign Type";
                                            const isStatus = heading === "Status";
                                            const sortKey = iscampaignName
                                                ? "campaignName"
                                                : isCampaignType
                                                    ? "campaignType"
                                                    : isStatus
                                                        ? "status"
                                                        : null

                                            return (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: "none",
                                                        padding: "12px 16px",
                                                        textAlign: "center",
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: "#3C0008",
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "4px",
                                                            color: "#ffffff",
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}

                                                        {sortKey && (
                                                            <span
                                                                onClick={() => handleSort(sortKey)}
                                                                style={{
                                                                    fontSize: "10px",
                                                                    color: "#ffffff",
                                                                    cursor: "pointer",
                                                                    marginLeft: "4px",
                                                                    userSelect: "none",
                                                                }}
                                                            >
                                                                {sortField === sortKey
                                                                    ? sortOrder === 1
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "▲▼"}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {histories.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography
                                                    sx={{
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '20px',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    No histories found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        histories.map((customer, index) => (
                                            <TableRow key={customer.customerId}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {limit === "all"
                                                            ? index + 1
                                                            : (page - 1) * Number(limit) + index + 1}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{customer.name || "-"}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{customer.email || "-"}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{customer.campaignName || "-"}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{customer.campaignType || "N/A"}</Typography></TableCell>
                                                <TableCell>
                                                    <Icon
                                                        icon={plusIcon}
                                                        width={20}
                                                        height={20}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleViewCampaign(customer)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="campaign-bottom">
                            <div className="campaign-section show-entries">
                                <span className="text-label">Show</span>
                                <select className="entries-select" value={limit} onChange={handleItemsPerPageChange}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value="all">All</option>
                                </select>
                                <span className="text-label">Entries</span>
                            </div>

                            <div className="campaign-section showing-range">
                                {limit === "all"
                                    ? `Showing all ${totalCount} entries`
                                    : `Showing ${(page - 1) * limit + 1} to ${Math.min(page * limit, totalCount)} of ${totalCount} entries`}
                            </div>

                            <div className="campaign-section spacer"></div>

                            {limit !== "all" && (
                                <div className="campaign-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={page === 1}
                                        onClick={() => handlePageChange("first")}
                                    >
                                        <Icon icon="mdi:chevron-double-left" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={page === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >
                                        <Icon icon="mdi:chevron-left" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={page === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >
                                        <Icon icon="mdi:chevron-right" />
                                    </button>
                                    <button
                                        className="pagination-btn"
                                        disabled={page === totalPages}
                                        onClick={() => handlePageChange("last")}
                                    >
                                        <Icon icon="mdi:chevron-double-right" />
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </main>
            </div >

        </div >

    );
};

export default CampaignHistoryPage;
